var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8223 21.0957C22.2363 21.0959 22.5723 21.4316 22.5723 21.8457C22.5721 22.2596 22.2362 22.5955 21.8223 22.5957H2.82227C2.40818 22.5957 2.07247 22.2597 2.07227 21.8457C2.07227 21.4315 2.40805 21.0957 2.82227 21.0957H21.8223Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99995 10.2568C6.41389 10.2568 6.74951 10.593 6.74995 11.0068V16.9043C6.74971 17.3183 6.41402 17.6543 5.99995 17.6543C5.58589 17.6543 5.2502 17.3183 5.24995 16.9043V11.0068C5.2504 10.593 5.58602 10.2568 5.99995 10.2568Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.154297C12.414 0.154297 12.7498 0.490254 12.75 0.904297V16.9043C12.75 17.3185 12.4142 17.6543 12 17.6543C11.5857 17.6543 11.25 17.3185 11.25 16.9043V0.904297C11.2502 0.490254 11.5859 0.154297 12 0.154297Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.23145C18.4139 4.23145 18.7496 4.56754 18.75 4.98145V16.9043C18.7498 17.3184 18.4141 17.6543 18 17.6543C17.5858 17.6543 17.2501 17.3184 17.25 16.9043V4.98145C17.2503 4.56754 17.586 4.23145 18 4.23145Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.696d120109ed79ffc07509063972d120.svg";
export { ForwardRef as ReactComponent };